module.exports = __webpack_public_path__ + "VIPV18.png?89e70d98cc47d0e6b68aa700e51a7b19";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV18.png
// module id = 112
// module chunks = 0